import Requester from "./Requester";

interface CreateDTO {
    name: string
    email: string
    description: string
}

export function getVendors() {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/vendors'))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/vendors`), values)
}

export default {
    create,
    getVendors,
}